export default __webpack_public_path__ + "static/media/gems.03b2017f.svg";